import { render } from "./BookChannelCom.vue?vue&type=template&id=3068abeb&scoped=true"
import script from "./BookChannelCom.vue?vue&type=script&lang=js"
export * from "./BookChannelCom.vue?vue&type=script&lang=js"

import "./BookChannelCom.vue?vue&type=style&index=0&id=3068abeb&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3068abeb"]])

export default __exports__